import { useToast } from '@app/core/notifications';
import { pushTo } from '@app/core/routing';
import { adminAuditPaths } from '@app/modules/audit/routing/admin-audit-paths';
import {
  auditReportsListReportDefinitionQueryKey,
  useAuditReportsCloneReportDefinition,
} from '@mi-front/api-v2';
import { FileCopy } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDefinitionContext } from '../../contexts/DefinitionContext';

export function CloneButton() {
  const { $t } = useIntl();
  const { notifySuccess, notifyError } = useToast();
  const { initialDefinition } = useDefinitionContext();
  const queryClient = useQueryClient();

  const cloneMutation = useAuditReportsCloneReportDefinition({
    mutation: {
      onSuccess: async (clonedDefinition) => {
        await queryClient.invalidateQueries({
          queryKey: auditReportsListReportDefinitionQueryKey({
            reportType: initialDefinition.reportType,
          }),
        });
        notifySuccess(
          $t({
            id: 'audit.reportDefinitions.cloneSuccess',
            defaultMessage: 'Plantilla clonada exitosamente',
          }),
        );
        pushTo(adminAuditPaths.reportDefinitionById(clonedDefinition.id));
      },
      onError: (error) => {
        notifyError(
          $t({
            id: 'audit.reportDefinitions.cloneError',
            defaultMessage: 'Error al clonar la plantilla',
          }),
        );
        console.error(error);
      },
    },
  });

  const handleClone = () => {
    cloneMutation.mutate({ id: initialDefinition.id });
  };

  return (
    <Button
      onClick={handleClone}
      loading={cloneMutation.isPending}
      variant="outlined"
      color="primary"
      size="small"
      startIcon={<FileCopy />}
    >
      <FormattedMessage id="audit.reportDefinitions.cloneButton" defaultMessage="Clonar" />
    </Button>
  );
}
